import modelService from '@/services/model'

export default {
  projectIndex: (cbOk, cbErr, projectId) => {
    return modelService.index(cbOk, cbErr, `/projects/${projectId}/members.json`)
  },

  userIndex: (cbOk, cbErr, userId) => {
    return modelService.index(cbOk, cbErr, `/users/${userId}/members.json`)
  },

  projectUpdate: (cbOk, cbErr, projectId, instance) => {
    return modelService.update(cbOk, cbErr, instance, `/projects/${projectId}/members/${instance.id}.json`)
  },

  projectDelete: (cbOk, cbErr, projectId, membershipId) => {
    return modelService.delete(cbOk, cbErr, `/projects/${projectId}/members/${membershipId}.json`)
  }
}



// WEBPACK FOOTER //
// ./src/services/member.js